<template>
  <v-dialog
    v-model="dialog"
    transition="slide-y-transition"
    width="600"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-bind="attrs"
        v-on="on"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card class="grey lighten-5">
      <v-card-title class="grey lighten-4">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = !dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form">
          <v-autocomplete
            label="Trecho"
            v-model="params.trecho"
            :items="options.trechos"
            clearable
            persistent-hint
            hint="Ao não selecionar nenhuma opção todos os registros são exibidos"
            multiple
          />
          <v-autocomplete
            label="Rodovia"
            v-model="params.rodovia"
            :items="options.rodovias"
            clearable
            multiple
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="reset()">Limpar</v-btn>
        <v-btn @click="addLayer()" color="primary">Pesquisar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import * as L from 'leaflet'
import { getBounds } from '@/domain/library'

import api from '@/api/vue-exemplo'

export default {
  name: 'Rodovias',
  data: () => ({
    name: 'der:sistema_rodoviario_lin_p31982',
    title: 'Sistema Rodoviário Estadual',
    dialog: false,
    params: {
      trecho: '',
      rodovia: ''
    },
    options: {
      trechos: [],
      rodovias: []
    }
  }),
  mounted () {
    this.getTrechos()
    this.getRodovias()

    this.$root.$on('initialLayer', () => {
      this.addLayer()
    })
  },
  methods: {
    reset () {
      this.$refs.form.reset()

      this.removeLayer()
      this.$root.$emit('fitBounds', getBounds())

      this.dialog = false
    },
    addLayer () {
      this.removeLayer()

      this.wmsLayer = L.tileLayer.wms(process.env.VUE_APP_GEOSERVER, {
        layers: this.name,
        format: 'image/png',
        transparent: true,
        pane: 'overlayPane',
        title: this.title 
        /*viewParams: toViewParams({
          pSistemaRodoviarioTrecho: this.params.trecho,
          pSistemaRodoviarioRodovia: this.params.rodovia
        })*/
      })

      this.$root.$emit('addWmsLayer', this.wmsLayer)

      var params = {
        service: 'wfs',
        version: '2.0.0',
        outputFormat: 'application/json',
        exceptions: 'application/json',
        request: 'GetFeature',
        typeNames: this.name,
        srsName: 'EPSG:4674',
        /*viewParams: toViewParams({
          pSistemaRodoviarioTrecho: this.params.trecho,
          pSistemaRodoviarioRodovia: this.params.rodovia
        })*/
      }

      if (this.params.trecho.length != 0){
        params.cql_filter = '('
        for (var trecho of this.params.trecho) {
          params.cql_filter += "trecho='" + trecho + "' OR "
        }
        params.cql_filter = params.cql_filter.slice(0, params.cql_filter.length-4) + ")"
      }
      if(this.params.rodovia.length != 0) {
        if(params.cql_filter) {
          params.cql_filter = params.cql_filter + " AND ("
        } else {
          params.cql_filter = '('
        }
        for (var rodovia of this.params.rodovia) {
          params.cql_filter += "rod_txt='" + rodovia + "' OR "
        }
        params.cql_filter = params.cql_filter.slice(0, params.cql_filter.length-4) + ")"
      }

      axios.get(process.env.VUE_APP_GEOSERVER, {
        params: params
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            /*onEachFeature: (feature, layer) => {
              var popupContent = "<table>"
              for(var header of this.template) {
                popupContent += "<tr><th>" + header.text + ":</th>" +
                  "<td>" + feature.properties[header.value] + "</td></tr>"
              }
              popupContent += "</table>"
              layer.bindPopup(popupContent)
            },*/
            style: () => {
              if(this.params.trecho.length != 0 || this.params.rodovia.length != 0) {
                return {
                  opacity: 0.3,
                  weight: 7
                }
              } else {
                return {
                  opacity: 0
                }
              }
            }
          })

          this.$root.$emit('addGeoJson', this.geojson)
        })
        .catch(error => {
          console.log(error)
        })

      this.dialog = false
    },
    removeLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
      }
      if (this.wmsLayer) {
        this.$root.$emit('removeWmsLayer', this.wmsLayer)
      }
    },
    getTrechos () {
      api.getTrechos()
        .then(response => {
          this.options.trechos = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getRodovias () {
      api.getRodovias()
        .then(response => {
          this.options.rodovias = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
